import React from "react";
import { useParams, useNavigate } from "react-router-dom";
import { WinExpectancyChart, GameLog, LoadingSkeleton, ErrorDisplay, KPIChips, GameHeader, GameLineups } from "../components/game";
import { useGameData } from "../hooks/useGameData";


const Card = ({ children }) => (
  <div className="bg-white p-3 sm:p-4 md:p-6 rounded-xl shadow-sm border border-gray-200">
    {children}
  </div>
);


export const GamePage = () => {
  const { year, gameId } = useParams();
  const navigate = useNavigate();
  const { gameData, loading, error } = useGameData(year, gameId);

  const handleBack = () => {
    if (gameData?.game_date) {
      navigate(`/scoreboard?date=${gameData.game_date}&division=${gameData.division}`);
    } else {
      navigate("/scoreboard");
    }
  };

  if (loading) return <LoadingSkeleton />;
  if (error) return <ErrorDisplay error={error} />;
  if (!gameData) return null;

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-100 relative overflow-hidden">
      <div className="relative z-10 container max-w-6xl mx-auto px-8 sm:px-12 lg:px-16 py-16">
        <GameHeader gameData={gameData} onBack={handleBack} />
        <KPIChips gameData={gameData} />
        <div className="space-y-4">
          <div className="h-px bg-gray-200" />
          <Card>
            <WinExpectancyChart homeTeam={(gameData.home_team)} awayTeam={(gameData.away_team)} homeTeamId={gameData.home_team_id} awayTeamId={gameData.away_team_id} plays={gameData.plays || []} />
          </Card>
          <div className="h-px bg-gray-200" />
          <Card>
            <div className="rounded-lg sm:rounded-xl">
              <GameLog plays={gameData.plays || []} homeTeam={(gameData.home_team)} awayTeam={(gameData.away_team)} />
            </div>
          </Card>
          <div className="h-px bg-gray-200" />
          <Card>
            <GameLineups 
              battingLineups={gameData.batting_lineups || []} 
              pitchingLineups={gameData.pitching_lineups || []}
              homeTeam={gameData.home_team}
              awayTeam={gameData.away_team}
              homeTeamId={gameData.home_team_id}
              awayTeamId={gameData.away_team_id}
            />
          </Card>
        </div>
      </div>
    </div>
  );
};
